import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FilesListComponent } from './files-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'convfact-filedelete',
    templateUrl: './files-dialog-delete.component.html',
    styleUrls: ['./files.component.css'],
    standalone: false
})

export class FilesDialogDeleteComponent {
  public message: string = this.data.message;

  constructor(
    public dialogRef: MatDialogRef<FilesListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string },
  ) { }

  public delete() {
    this.dialogRef.close(true);
  }

  public closeDialog() {
    this.dialogRef.close(false);
  }

}
